import { render, staticRenderFns } from "./ConfigGlobal.vue?vue&type=template&id=66a95dc4&lang=pug&"
import script from "./ConfigGlobal.vue?vue&type=script&lang=js&"
export * from "./ConfigGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports